<footer id="site-footer" class="mt-auto w-full">
    <div class="mx-[20px] sm:mx-[80px] xl:!mx-auto max-w-7xl min-h-[124px] pt-[40px] pb-[56px]">
        <div class="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
            <!-- Left content: Copyright + Links -->
            <div class="flex flex-col items-start gap-6 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6 sm:gap-y-2">
                <span class="text-sm">
                    {{ copyright }}
                </span>
                @for (link of links; track link.href) {
                    <a
                        [href]="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-sm underline transition-all duration-200"
                    >
                        {{ link.title | translate }}
                    </a>
                }
            </div>

            <!-- Right content: Powered by -->
            <a
                [href]="poweredByHref"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-medium whitespace-nowrap align-self-start underline transition-all duration-200"
            >
                {{ poweredBy }}
            </a>
        </div>
    </div>
</footer>
